import { Modal } from "react-bootstrap"
import { modal as modalText, resume } from "../../../i18n/pt.json"
import * as S from "./styled"

export const Layout = ({ type, handleCheckout, show, handleShow, handleClose }) => {
  const { checkout: text } = modalText
  return (
    <>
      <span onClick={handleShow}>
        <S.SolidButton>{resume.finish[type]}</S.SolidButton>
      </span>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        aria-labelledby="contained-modal-title-top"
        top
        onClick={(e) => e.stopPropagation()}
        keyboard={false}
      >
        <S.Header closeButton>
          <S.Title>{text.title}</S.Title>
        </S.Header>

        <Modal.Body>
          <S.BodyText>{text[type]}</S.BodyText>
        </Modal.Body>

        <S.Footer>
          <S.Deny onClick={handleClose}>
            <S.DenyText>{text.deny}</S.DenyText>
          </S.Deny>
          <S.Confirm onClick={handleCheckout}>{text.confirm}</S.Confirm>
        </S.Footer>
      </Modal>
    </>
  )
}
